module.exports = require("remark-squeeze-paragraphs");


//////////////////
// WEBPACK FOOTER
// external "remark-squeeze-paragraphs"
// module id = 60
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13